import { resolveRoute } from "vike/routing";
import type { PageContext } from "vike/types";

export function route(pageContext: PageContext) {
  const { urlPathname } = pageContext;

  const withTab = resolveRoute("/@slug/results/@tab", urlPathname);
  if (withTab.match) {
    if (withTab.routeParams.tab !== "favorites") return false;
    return {
      routeParams: { slug: withTab.routeParams.slug, tab: "favorites" },
    };
  }

  const base = resolveRoute("/@slug/results", urlPathname);
  if (base.match) {
    return { routeParams: { slug: base.routeParams.slug, tab: "search" } };
  }

  return false;
}
